<template>
    <input ref="element" v-on:change="changedEvent" :name="name" :v-validate="validate" :data-vv-name="name" type="text" placeholder="" class="form-control" v-bind:class="{'daterange-single': single, 'daterange': !single}" v-model='periodSet' />
</template>

<script>

import Vue from 'vue'
import 'daterangepicker'
import $ from 'jquery'

export default {
  name: 'DateRangePicker',
  props: ['validate', 'period', 'name', 'single'],
  data () {
    return {
      periodSet: '',
      selectedClass: 'daterange',
      optionsDp: {}
    }
  },
  watch: {
    'periodSet': function (val) {
      this.changedEvent(val)
    }
  },
  beforeMount () {
    this.optionsDp = {
      applyClass: 'bg-slate-600',
      cancelClass: 'btn-default',
      template: Vue.config.dateRangePicker.template
    }

    if (this.single) {
      this.selectedClass += '-single'
      this.optionsDp = {
        template: Vue.config.dateRangePicker.template,
        singleDatePicker: this.single
      }
    }
  },
  mounted () {
    this.changedEvent(this.period)
    $(this.$refs.element).daterangepicker(this.optionsDp).on('change.daterangepicker', (e) => { this.changedEvent(e.data || e.currentTarget.value) })
  },
  created () {
  },
  methods: {
    changedEvent (val) {
      if (val !== this.periodSet) {
        if (val !== '' && typeof val !== 'undefined') {
          this.periodSet = this.$moment(val, Vue.config.localizedFormat.date).format(Vue.config.localizedFormat.date)
          this.$emit('periodchanged', val)
        }
      }
    }
  },
  beforeDestroy () {
    if ($('.' + this.selectedClass).data('daterangepicker')) {
      $('.' + this.selectedClass).data('daterangepicker').remove()
    }
    $('.daterangepicker').remove()
  }
}
</script>

<style scoped>
    .form-control {
        width: 100%;
    }
</style>
